<template>
  <v-app id="app">
    <div id="loading" ref="loading">
      <div id="loading-center">
        <div id="loading-center-absolute">
          <div class="object" id="object_one"></div>
          <div class="object" id="object_two"></div>
          <div class="object" id="object_three"></div>
        </div>
      </div>
    </div>
    <v-toolbar absolute app color="#393D40" dense flat v-if="showNavbar">
      <v-toolbar-title>
        <v-img
          aspect-ratio="1"
          @click="goWebContent"
          contain
          :lazy-src="require('@/assets/logo_footer.png')"
          :src="require('@/assets/logo_footer.png')"
          width="100"
        ></v-img>
      </v-toolbar-title>
      <!-- Main Menu -->
      <template v-for="item in items">
        <!-- child toggle -->
        <v-list-group :key="item.title" v-if="item.children" v-model="item.model">
          <!-- header title -->
          <v-list-tile slot="item">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>{{ item.model ? item.icon : item['icon-alt'] }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <!-- menu in title -->
          <v-list-tile :key="i" router :to="child.link" v-for="(child, i) in item.children">
            <v-list-tile-content>
              <v-list-tile-title>{{ child.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <!-- other menu -->
        <v-list-tile :key="item.title" router :to="item.link" v-else>
          <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>-->
          <v-list-tile-content>
            <v-list-tile-title>
              <v-icon color="grey accent-3">{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <v-spacer></v-spacer>
    </v-toolbar>

    <notification></notification>

    <ShopCarts />

    <v-content v-cloak>
      <transition mode="out-in" name="slide-fade">
        <router-view :key="$route.fullPath" />
      </transition>
    </v-content>

    <v-footer color="#393D40" height="auto">
      <v-container grid-list-xl>
        <v-layout align-center justify-center row wrap>
          <v-flex pb-0 sm2 xs5>
            <v-img
              :lazy-src="require('@/assets/logo_footer.png')"
              :src="require('@/assets/logo_footer.png')"
              width="100%"
            ></v-img>
          </v-flex>
          <v-flex class="white--text" pb-0 sm4 text-xs-center xs12>
            <div style="font-size:9px;opacity:0.5">
              5/32 ม.4 ซ.จันทร์ประสงค์ บางกรวยไทรน้อยซอย 6
            </div>
            <div style="font-size:9px;opacity:0.5">
              ต.บางกรวย อ.บางกรวย จ.นนทบุรี 11130 ประเทศไทย
            </div>
            <div class="subheading">(+66) 0933171414</div>
          </v-flex>
          <v-flex class="py-1" xs12></v-flex>
        </v-layout>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import Notification from '@/components/Notification.vue'
import ShopCarts from '@/components/shop/ShopCarts'
export default {
  name: 'App',
  components: {
    Notification,
    ShopCarts
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,
      showNavbar: true,
      // items: [{ title: 'หน้าแรก', link: '/' }, { title: 'เกี่ยวกับ', link: '/about' }]
      items: []
    }
  },
  watch: {
    $route() {
      this.$refs.loading.style.display = 'inherit'
      setTimeout(() => {
        this.$refs.loading.style.display = 'none'
      }, 2000)
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'FarmerSpace',
    // all titles will be injected into this template
    titleTemplate: '%s | เครือข่ายสังคมออนไลน์ภาคการเกษตร รวมพลังเกษตรกรไทย',
    // Define meta tags here.
    meta: [
      {
        vmid: 'title',
        name: 'title',
        content: 'FarmerSpace | เครือข่ายสังคมออนไลน์ภาคการเกษตร รวมพลังเกษตรกรไทย'
      },
      {
        vmid: 'description',
        name: 'description',
        content:
          'เครือข่ายสังคมออนไลน์ภาคการเกษตร รวมพลังเกษตรกรไทย ในยุคเมืองไทย 4.0 แหล่งรวบรวมผลผลิตทางการเกษตร เพื่อสนับสนุนการขยายตัวของภาคอุตสาหกรรม'
      }
    ],
    noscript: [
      {
        innerHTML:
          "We're sorry but FarmerSpace doesn't work properly without JavaScript enabled. Please enable it to continue."
      }
    ]
  },
  async mounted() {
    setTimeout(() => {
      this.$refs.loading.style.display = 'none'
    }, 2000)
    await this.$store.dispatch('Content/fetch')
    await this.$store.dispatch('Product/fetchProductName')
    this.$store.dispatch('Product/fetchProductSearch')
    this.$store.dispatch('Place/fetchCountry')
    this.$store.dispatch('Place/fetchRegion')
    this.$store.dispatch('Place/fetchProvince')
    this.$store.dispatch('Place/fetchDistrict')
    this.$store.dispatch('Place/fetchSubDistrict')
  },
  methods: {
    goWebContent() {
      window.location.href = 'https://content.farmerspace.co'
    }
  }
}
</script>

<style lang="scss">
/* Media query */
@import 'mq';
/* Google font */
@import url('https://fonts.googleapis.com/css?family=Secular+One:300,400');
@import url('https://fonts.googleapis.com/css?family=Quicksand:300,400');
@import url('https://fonts.googleapis.com/css?family=Prompt:300,400,600,700');
@import url('https://fonts.googleapis.com/css?family=Kanit:300,400,500,700');

@font-face {
  font-family: 'THSarabunNew';
  src: url('./assets/font/THSarabunNew/THSarabunNew.eot?#iefix') format('embedded-opentype'),
    url('./assets/font/THSarabunNew/THSarabunNew.woff') format('woff'),
    url('./assets/font/THSarabunNew/THSarabunNew.ttf') format('truetype'),
    url('./assets/font/THSarabunNew/THSarabunNew.svg#THSarabunNew') format('svg');
  font-weight: normal;
  font-style: normal;
}
.font-THSarabunNew {
  font-family: 'THSarabunNew';
  font-size: 22px;
  letter-spacing: 1px;
  color: #000;
  line-height: 1.3em;
}
.body-1 {
  font-family: 'THSarabunNew';
}
// $menuColor: #c8cfd3;
html {
  font-family: 'Prompt' !important;
}
html::-webkit-scrollbar {
  display: none;
}

#app {
  background: #fff;
  font-family: 'Prompt';
  overflow-x: hidden;
  // font-family: 'Secular One' !important;
  // font-family: 'Quicksand' !important;
  & .display-1,
  .headline,
  .title,
  .body-2,
  .caption {
    font-family: 'Prompt' !important;
  }
  .subheading {
    letter-spacing: 0px;
  }
  .spacing {
    letter-spacing: 2px !important;
  }
  & .head-page {
    font-family: 'Prompt' !important;
    // font-family: 'Quicksand' !important;
  }
}
#knowledge-detail {
  & .knowledge-content {
    & span {
      font-family: 'THSarabunNew' !important;
      font-size: 22px !important;
      word-wrap: break-word;
    }
    & p {
      margin-bottom: 0px;
    }
    & img {
      max-width: 100%;
      height: auto;
    }
  }
}
img {
  &.aligncenter {
    clear: both;
    margin-top: 0;
    margin-bottom: 1.6em;
  }
  .size-full {
    max-width: 100%;
    height: auto;
    width: 100%;
  }
}

.mouse-pointer {
  cursor: pointer;
}
.search-box {
  & .v-input__control {
    min-height: 30px !important;
  }
  & .v-input__slot {
    padding: 6px 28px !important;
    border-radius: 24px !important;
    box-shadow: none !important;
    min-height: 30px !important;
    background: #eef1f2 !important;
  }
  &.v-text-field input {
    font-size: 14px;
  }
  & .input-group__input {
    padding: 0 16px !important;
  }
  & label {
    font-size: 14px;
  }
}
.consulting-box {
  & .v-input__control {
    min-height: 30px !important;
  }
  & .v-input__slot {
    border-radius: 16px !important;
    & textarea {
      line-height: 25px;
      margin-top: 6px !important;
      font-size: 14px;
    }
    padding: 0px 18px !important;
    box-shadow: none !important;
    min-height: 30px !important;
    background: #eef1f2 !important;
  }
  &.v-text-field input {
    font-size: 14px;
  }
  & .input-group__input {
    padding: 0 16px !important;
  }
  & label {
    line-height: 2em;
    font-size: 16px;
  }
}
.question-box {
  & .v-input__control {
    min-height: 30px !important;
  }
  & .v-input__slot {
    & textarea {
      line-height: 25px;
      margin-top: 6px !important;
      font-size: 14px;
    }
    padding: 0px 18px !important;
    box-shadow: none !important;
    min-height: 30px !important;
    background: #eef1f2 !important;
  }
  &.v-text-field input {
    font-size: 14px;
  }
  & .input-group__input {
    padding: 0 16px !important;
  }
  & label {
    line-height: 2em;
    font-size: 16px;
  }
}
#base-autocomplete-product {
  & .v-input__slot,
  .v-label {
    font-size: 14px;
    color: #d4d4d4;
    letter-spacing: 2px;
  }
}
.v-list__tile__title {
  font-size: 14px;
  letter-spacing: 2px;
}
[v-cloak] {
  display: none;
}
#loading {
  background-color: #00c853;
  height: 100%;
  width: 100%;
  position: fixed;
  z-index: 1;
  margin-top: 0px;
  top: 0px;
}
#loading-center {
  width: 100%;
  height: 100%;
  position: relative;
}
#loading-center-absolute {
  position: absolute;
  left: 50%;
  top: 50%;
  height: 100px;
  width: 40px;
  margin-top: -50px;
  margin-left: -20px;
}
.object {
  width: 40px;
  height: 8px;
  margin-bottom: 20px;
  background-color: #fff;
  -webkit-animation: animate 0.8s infinite;
  animation: animate 0.8s infinite;
}

#object_two {
  -webkit-animation-delay: 0.2s;
  animation-delay: 0.2s;
}
#object_three {
  -webkit-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

@-webkit-keyframes animate {
  50% {
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}

@keyframes animate {
  50% {
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    transform: scale(1.5);
  }
}
</style>
